import '../styles/ContactUs.css';
import callIcon from '../assets/images/icons/phone_in_talk_100dp_FFFFFF_FILL1_wght400_GRAD0_opsz48.png';
import emailIcon from '../assets/images/icons/mail_100dp_FFFFFF_FILL1_wght400_GRAD0_opsz48.png';

// WhatsApp isn't listed here: the floating WhatsApp button is already on every page
const channels = [
    { icon: callIcon, title: "Call us", detail: "+27 64 540 6751", href: "tel:+27645406751", action: "Call now", tone: "navy" },
    { icon: emailIcon, title: "Email us", detail: "info@kolemedical.co.za", href: "mailto:info@kolemedical.co.za", action: "Send an email", tone: "orange" },
];

// Shared by the homepage and the Contact page
const ContactUs = () => {
    return(
        <section className="km-section km-section--alt contactContainer" id="contact">
            <div className="km-container">
                <div className="km-sectionHead km-sectionHead--center" data-reveal>
                    <p className="km-eyebrow">Contact</p>
                    <h2 className="km-title">Talk to a consultant</h2>
                    <p className="km-lead">Questions about SAHPRA licensing? Call or email us directly.</p>
                </div>
                <div className="contact-grid">
                    {channels.map((channel, index) => (
                        <a
                            key={channel.title}
                            className="km-card contactCard"
                            href={channel.href}
                            data-reveal
                            style={{ "--reveal-order": index } as React.CSSProperties}
                        >
                            <span className={`contact-icon contact-icon--${channel.tone}`}>
                                <img src={channel.icon} alt="" />
                            </span>
                            <span className="contact-title">{channel.title}</span>
                            <span className="contact-detail">{channel.detail}</span>
                            <span className="contact-action">{channel.action} <span className="km-arrow" aria-hidden="true">→</span></span>
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default ContactUs;
